import { OPTIN_CODES } from "../../../constants/OptinCodes"
import { loc } from "../../../core/utils"
import Optin from "../../../form/Optin"
import OptinPrivacyPR from "../../../form/OptinPrivacyPR"
import React from "react"
import { Col } from "react-bootstrap"

function Optins({ optins, tunnelData, showWeAskConsentTextBeforeOptins }) {
  const { tenant } = tunnelData
  // There is an optin specific to PR journeys that require a custom component
  const optinPrivacy = optins?.find((x) => x.code === OPTIN_CODES.SAMSUNG_IT_PRIVACY_POLICY_AGREEMENT)

  const optinsToRender = getOptinsExceptCode(optins, OPTIN_CODES.SAMSUNG_IT_PRIVACY_POLICY_AGREEMENT)

  function getOptinsExceptCode(optinsInput, code) {
    if (!optinsInput || optinsInput.length === 0) return []
    return optinsInput.filter((x) => x.code !== code)
  }

  if (!optinsToRender || optinsToRender.length === 0) return null

  return (
    <Col className="radiofields optin-radio">
      {!!optinPrivacy ? <OptinPrivacyPR optin={optinPrivacy} tenant={tenant} /> : null}

      {optinsToRender.map((optin, index) => (
        <React.Fragment key={optin.code}>
          {index === 0 && showWeAskConsentTextBeforeOptins && (
            <p className="optin">{loc`We ask your consent for all the purposes described in data processing :`}</p>
          )}
          <Optin optin={optin} tenant={tenant} tunnelData={tunnelData} />
        </React.Fragment>
      ))}
    </Col>
  )
}

export default Optins
